import { Result, ResultId } from '@collector/sportsapi-client-legacy'
import { useParticipantResultsMaps } from '@desktop/views/Relation/composables'

type UseResults = {
  hasParticipantsResultId(resultId: ResultId): boolean
}
export function useResults(): UseResults {
  const { homeParticipantResultsMap, awayParticipantResultsMap } =
    useParticipantResultsMaps()

  function hasParticipantsResultId(resultId: ResultId): boolean {
    const resultForHome = homeParticipantResultsMap.value[resultId]
    const resultForAway = awayParticipantResultsMap.value[resultId]

    return isResultValid(resultForHome) && isResultValid(resultForAway)
  }

  function isResultValid(result: Result | undefined): boolean {
    if (!result) {
      return false
    }
    return result.value !== null
  }

  return { hasParticipantsResultId }
}
